var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongQiye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tongyong_qiye_svg__clip0_5239_55458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 11h3M9 8h3M9 5h3",
    stroke: "#3F465C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 1.5a.75.75 0 00-.75.75V5.5H2.25a.75.75 0 00-.75.75v7.25H1a.5.5 0 000 1h14a.5.5 0 000-1h-.5V2.25a.75.75 0 00-.75-.75h-6.5zm-.75 12v-3H4a.5.5 0 010-1h2.5v-3h-4v7h4zm1 0h6v-11h-6v11z",
    fill: "#3F465C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tongyong_qiye_svg__clip0_5239_55458"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
export default __webpack_public_path__ + "static/tongyong_qiye.a69871fa.svg";
export { SvgTongyongQiye as ReactComponent };